import styles from './NavLojista.module.scss';
import { useAuth } from 'shared/contexts/Auth/AuthContext';
import { useNavigate } from 'react-router-dom';
import { MenuLojista } from '../menuLojista/MenuLojista';
import { useState } from 'react';

export const NavLojista = () => {
  const [menuPop, setMenuPop] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate('minhaconta');
  };

  const handleClickMenu = () => {
    setMenuPop(!menuPop);
  };

  const handleCloseMenu = () => {
    setMenuPop(false);
  };

  return (
    <div className={styles.navegacao}>
      {/* Botão do menu */}
      <div className={styles.containerNav}>
        <button className={styles.btnNav} onClick={handleClickMenu}>
          <img src="/icons/menuBlack.png" alt="Menu" className={styles.iconMenu} />
        </button>
      </div>

      {/* Overlay escuro + menu lateral */}
      {menuPop && <div className={styles.overlay} onClick={handleCloseMenu}></div>}

      <div className={`${styles.sidebar} ${menuPop ? styles.open : ''}`}>
        <MenuLojista handleClose={handleCloseMenu} />
      </div>

      {/* Informações do usuário */}
      <div className={styles.menuuser}>
        <button onClick={handleButtonClick} className={styles.btnuser}>
            <img
              src={user?.imageUser || '/imagens/foto.png'}
              alt={user?.name || 'Profile'}
              className={styles.imguser}
            />
        </button>
        <div className={styles.containerDados}>
          <p className={styles.userName}>{user?.name}</p>
          <p className={styles.userEmail}>{user?.email}</p>
        </div>
      </div>
    </div>
  );
};
